// Single source of truth for jobs.status.
//
// The DB constraint (jobs_status_check) allows exactly these values, spelled
// with the double-L 'cancelled'. Anything that needs to ask "is this job done?"
// should go through here rather than comparing strings inline — the bug this
// replaces was several call sites treating 'cancelled' as a flavour of
// 'completed', or inferring completion from a date column instead of status.

export const JOB_STATUSES = ['draft', 'pending', 'scheduled', 'active', 'on_hold', 'completed', 'cancelled']

// Statuses a job can still be worked, scheduled, or billed under.
export const ACTIVE_STATUSES = ['draft', 'pending', 'scheduled', 'active', 'on_hold']

// Statuses that put a job on the crew schedule board / ordering queue. Narrower
// than ACTIVE_STATUSES: a draft or pending job is not ready to be crewed.
// Matches the long-standing list in utils/jobOrdering.js.
export const SCHEDULABLE_STATUSES = ['scheduled', 'active', 'on_hold']

// Statuses that end a job's life. Terminal, but NOT interchangeable:
// completed earned money, cancelled never happened.
export const TERMINAL_STATUSES = ['completed', 'cancelled']

export function isCancelled(job) {
  return getStatus(job) === 'cancelled'
}

export function isCompleted(job) {
  return getStatus(job) === 'completed'
}

// Ended one way or the other. Use only where the two genuinely behave the same
// (e.g. "don't let anyone clock in"), never for display or money.
export function isTerminal(job) {
  return TERMINAL_STATUSES.indexOf(getStatus(job)) !== -1
}

export function isActiveStatus(job) {
  return ACTIVE_STATUSES.indexOf(getStatus(job)) !== -1
}

export function statusLabel(job) {
  var s = getStatus(job)
  if (s === 'cancelled') return 'CANCELLED'
  if (s === 'completed') return 'DONE'
  if (s === 'on_hold') return 'ON HOLD'
  return (s || 'scheduled').toUpperCase()
}

function getStatus(jobOrStatus) {
  if (jobOrStatus == null) return null
  return typeof jobOrStatus === 'string' ? jobOrStatus : jobOrStatus.status
}
